/**
 * Crawlable home tags. index.html repeats these literals so a social
 * crawler sees them before JavaScript runs. The sitemap test checks they match.
 */
export const HOME_TITLE = 'Marshal | Swim club management software for NZ clubs';

export const HOME_DESCRIPTION =
  'Bookings, invoicing, and Xero sync for New Zealand swim clubs, plus a parent app for sessions, fees, meets, and squad news. One desk for the club.';

export function homeTitle(brandName: string): string {
  return `${brandName} | Swim club management software for NZ clubs`;
}
